import * as Config from '../../../../../../config';
import React from 'react';
import PropTypes from 'prop-types';
import '../../../LinkModal.css';

import LogoLink from '../../svg/LogoLink';

function NoSubscriptionPM({ cancelClick, modalHasEntered }) {
  const trial = () => { window.open(Config.REDIRECT_TRIAL, `_blank`) }
  const redirect = () => { window.open(`https://stream.beatsource.com/?utm_medium=referral&utm_source=dj_web_app&utm_campaign=evergreen`, `_blank`) }
  return (
    <div className={`flexColumn cta pm-no-sub`}>
      <div className={`flexColumn modalV2 bottom-reduce`}>
        <div className={`flexColumn body`} >
          <div className={`logo center`}>
            <LogoLink />
          </div>
          <div className={`title`}>A Beatsource Streaming account is required to DJ in B2B Mode.</div>
          <div className={`flexColumn description`} >
            To collaborate B2B with up to three others, all DJ’s must have an active Beatsource Streaming account.  Try free for 30-days.
          </div>
          <div className={`flexRow group-cta`}>
            <div className={`cta primary half`} onClick={trial}>Free 30-Day Trial</div>
            <div className={`cta transparent-grey half`} onClick={redirect}>Learn More</div>
            <div className={`cta cancel`} onClick={cancelClick}>No Thanks</div>
          </div>
        </div>
      </div>
    </div>
  )
}

NoSubscriptionPM.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default NoSubscriptionPM;
